import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs';
import { StorageService } from './storage.service';
import {
  RawLoginData,
  ParsedLoginData,
  ProcessedLoginData
} from './../login-data-types';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

const AUTH_API = `${environment.api}/auth`;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  withCredentials: true
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public chosenUser: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private router: Router
  ) {}

  getChosenUser(): any {
    return this.chosenUser.value;
  }

  setChosenUser(user: any) {
    this.chosenUser.next(user);
  }

  login(loginData: RawLoginData): Observable<ProcessedLoginData> {
    let url: string = `${AUTH_API}/login`;
    return this.http.post<ProcessedLoginData>(url, loginData, httpOptions).pipe(
      tap(
        response => {
          this.storageService.saveUserToken(response.authorization.token);
        },
        error => {
          console.log(error);
        }
      ),
      catchError(this.handleError<ProcessedLoginData>('login'))
    );
  }

  autoLogin(): Observable<any> {
    return this.http.get<any>(AUTH_API + '/check-remember-me', {
      withCredentials: true
    });
  }

  //REGISTER FUNCTION HERE?...

  logout(): Observable<any> {
    let url: string = `${AUTH_API}/logout`;

    return this.http.post(url, {}).pipe(
      tap(_ => {
        this.storageService.clean();
        this.setChosenUser(null);
      }),
      catchError(this.handleError<any>(`logout`))
    );
  }

  forgot_password(email?: any): Observable<any> {
    return this.http.post<any>(AUTH_API + '/forgot_password', { email });
  }

  reset_password(
    token: any,
    password: any,
    password_confirmation: any
  ): Observable<any> {
    return this.http.post<any>(AUTH_API + '/reset', {
      token,
      password,
      password_confirmation
    });
  }

  userLogged() {
    return this.http.get<any>(AUTH_API + '/me');
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      return of(result as T);
    };
  }

  createUser(userData: any): Observable<any> {
    return this.http.post<any>(AUTH_API + '/registerUser', userData);
  }

  getRoles() {
    return of({ result: [] });
  }

  getAssignment() {
    return of({ result: [] });
  }

  getExpertise() {
    return of({ result: [] });
  }

  changePassword(data: any): Observable<any> {
    return this.http.put<any>(AUTH_API + `/changePassword`, data);
  }
}
